// extracted by mini-css-extract-plugin
module.exports = {"highlights":"Jt7TR","nic":"tDfrK","doubledot_heading":"RPTTD","cDataDiv":"S57o4"};